import React from 'react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { IconButton } from 'react-toolbox/lib/button'

const StatusIcon = (props) => {
    const {
        iconName,
        color
    } = props

    var styleName = styles.circle
    styleName += ' ' + styles[color]

    return(
        <Flex className={styleName} justify='center' align='center'>
            <IconButton icon={iconName} theme={styles} />
        </Flex>
    )
}

export default CSSModules(styles)(StatusIcon)
